export const checkZoom = (siteLocationGlobalData, singleSiteLocationData, site) => {
    if (siteLocationGlobalData) {
      return 4;
    } else if (singleSiteLocationData) {
      return 15;
    } else if (site) {
      return 14.5;
    } else {
      return 0;
    }
  };